<div class="h-full flex flex-col gap-2 z-0 relative overflow-y-auto  p-2 lg:pl-0">
    <div
        class="max-w-6xl p-4 rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg">
        <form [formGroup]="employeeForm" (ngSubmit)="onSave()">
            <h1 class="heading">
                {{employeeId ? 'Edit' : 'Add'}}
            </h1>
            <hr class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
            <section class="grid gap-4 sm:grid-cols-2">
                <!-- name -->
                <div class="space-y-1">
                    <label class="subheading after:text-red-600 after:content-['*']">
                        Name
                    </label>
                    <div>
                        <div>
                            <input formControlName="GivenName" type="text" />
                        </div>
                        <div *ngIf="submitted && form.GivenName.errors">
                            <p *ngIf="form?.GivenName?.errors?.required" class="pt-1 text-red-600 text-xs">
                                Name is required
                            </p>
                        </div>
                    </div>
                </div>

                <!-- Family name -->
                <div class="space-y-1">
                    <label class="subheading after:text-red-600 after:content-['*']">
                        Family Name
                    </label>
                    <div>
                        <div>
                            <input formControlName="FamilyName" type="text" />
                        </div>
                        <div *ngIf="submitted && form.FamilyName.errors">
                            <p *ngIf="form.FamilyName.errors.required" class="pt-1 text-red-600 text-xs">
                                Family Name is required
                            </p>
                        </div>
                    </div>
                </div>

                <!-- SSN -->
                <div class="space-y-1">
                    <label class="subheading after:text-red-600 after:content-['*']">
                        SSN
                    </label>
                    <div>
                        <div>
                            <input placeholder="xxx-xx-xxxx" formControlName="SSN" type="text" />
                        </div>
                        <div *ngIf="submitted && form.SSN.errors">
                            <p *ngIf="form.SSN.errors.required" class="pt-1 text-red-600 text-xs">
                                SSN is required
                            </p>
                            <p class="pt-1 text-red-600 text-xs" *ngIf="employeeForm.get('SSN')?.errors?.['pattern']">
                                SSN must be in the format XXX-XX-XXXX.
                            </p>
                        </div>
                    </div>
                </div>

                <!-- Contact -->
                <ng-container formGroupName="PrimaryPhone">
                    <div class="space-y-1">
                        <label class="subheading after:text-red-600 after:content-['*']">
                            Free Form Number
                        </label>
                        <div>
                            <div>
                                <input formControlName="FreeFormNumber" type="text" />
                            </div>
                            <div *ngIf="submitted && primaryPhone.get('FreeFormNumber')?.errors">
                                <p *ngIf="primaryPhone.get('FreeFormNumber')?.errors?.required"
                                    class="pt-1 text-red-600 text-xs">
                                    Form Number is required
                                </p>
                                <!-- <p *ngIf="submitted && form.phoneNumber.errors?.minlength || submitted && form.phoneNumber.errors.maxlength"
                  class="pt-1 text-red-600 text-xs">
                  Minimum 10 digits are required and maximum 11 digits are allowed
                </p> -->
                            </div>

                        </div>
                    </div>
                </ng-container>

                <!-- address -->
                <ng-container formGroupName="PrimaryAddr">

                    <!-- line1 -->
                    <div class="space-y-1">
                        <label class="subheading after:text-red-600 after:content-['*']">
                            Address
                        </label>
                        <div>
                            <div>
                                <input googlePlace (onSelect)="onSelectAddress($event)" formControlName="Line1"
                                    name="Line1" id="Line1" type="text" />
                            </div>
                        </div>

                        <div *ngIf="submitted && (primaryAddr.get('Line1')?.errors)">
                            <p *ngIf="primaryAddr.get('Line1')?.errors?.required" class="pt-1 text-red-600 text-xs">
                                Line1 is required
                            </p>
                        </div>
                    </div>

                    <!-- CountrySubDivisionCode -->
                    <div class="space-y-1">
                        <label class="subheading after:text-red-600 after:content-['*']">
                            Country Sub Division Code
                        </label>
                        <div>
                            <div>
                                <input formControlName="CountrySubDivisionCode" name="CountrySubDivisionCode"
                                    placeholder="" id="address" type="text" />
                            </div>
                        </div>

                        <div *ngIf="submitted && (primaryAddr.get('CountrySubDivisionCode')?.errors)">
                            <p *ngIf="primaryAddr.get('CountrySubDivisionCode')?.errors?.required"
                                class="pt-1 text-red-600 text-xs">
                                Country Sub Division Code is required
                            </p>
                        </div>
                    </div>

                    <!-- city -->
                    <div class="space-y-1">
                        <label class="subheading after:text-red-600 after:content-['*']">
                            City
                        </label>
                        <div>
                            <div>
                                <input formControlName="City" name="City" id="City" type="text" />
                            </div>
                            <div *ngIf="submitted && (primaryAddr.get('City')?.errors)">
                                <p *ngIf="primaryAddr.get('City')?.errors?.required" class="pt-1 text-red-600 text-xs">
                                    City is required
                                </p>
                            </div>

                        </div>
                    </div>

                    <!-- Postal code -->
                    <div class="space-y-1">
                        <label class="subheading after:text-red-600 after:content-['*']">
                            Postal Code
                        </label>
                        <div>
                            <div>
                                <input formControlName="PostalCode" name="PostalCode" id="PostalCode" type="text" />
                            </div>
                            <div *ngIf="submitted && (primaryAddr.get('PostalCode')?.errors)">
                                <p *ngIf="primaryAddr.get('PostalCode')?.errors?.required"
                                    class="pt-1 text-red-600 text-xs">
                                    Postal Code is required
                                </p>
                            </div>

                        </div>
                    </div>

                </ng-container>

                <div *ngIf="!employeeId" class="space-y-1">
                    <label class="subheading">Company</label>
                    <div>
                        <select [(ngModel)]="selectedCompany" id="Company" [ngModelOptions]="{standalone: true}">
                            <option value="" disabled>Select company</option>
                            <option *ngFor="let item of companies" [value]="item.id">
                                {{ item.CompanyName | capitalize }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="space-y-1">
                    <div formGroupName="reference" class="flex gap-2">
                        <div class="w-1/2">
                            <label class="subheading">
                                Ref Name
                            </label>
                            <div>
                                <div>
                                    <input formControlName="name" name="name" id="name" type="text" />
                                </div>
                            </div>
                        </div>
                        <div class="w-1/2">
                            <label class="subheading">
                                Ref ID
                            </label>
                            <div>
                                <div>
                                    <input formControlName="id" name="id" id="id" type="text" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
            <section class="flex justify-end gap-4">
                <button type="submit" class="btn btn-secondary">
                    {{employeeId ? 'Update' : 'Save'}}

                </button>
            </section>
        </form>
    </div>
</div>